import { useEffect, useState } from 'react';
import { getApiBaseUrl } from '@/services/api';

export interface UniversePoint {
  period: string;
  roofing?: number | null;
  roofingYoy?: number | null;
  insulation?: number | null;
  insulationYoy?: number | null;
  doors?: number | null;
  doorsYoy?: number | null;
  ocRoofing?: number | null;
  ocRoofingYoy?: number | null;
  ocInsulation?: number | null;
  ocInsulationYoy?: number | null;
  cslCcm?: number | null;
  cslCcmYoy?: number | null;
}

export interface UniverseEvidence {
  id: string;
  company: string;
  symbol: string;
  when: string;
  head: string;
  body: string;
  foot: string;
  badge: string;
}

export interface UniverseSnapshot {
  version: number;
  generatedAt: string;
  source: string;
  oc: UniversePoint[];
  compare: UniversePoint[];
  evidence: UniverseEvidence[];
  coverageNote: string;
}

export type UniverseState =
  | { status: 'loading'; data: null; error: null }
  | { status: 'ready'; data: UniverseSnapshot; error: null }
  | { status: 'error'; data: null; error: string };

export function useQxoUniverse(): UniverseState {
  const [state, setState] = useState<UniverseState>({ status: 'loading', data: null, error: null });

  useEffect(() => {
    const controller = new AbortController();
    fetch(`${getApiBaseUrl()}/api/qxo/universe`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      signal: controller.signal,
    })
      .then(async (res) => {
        if (!res.ok) {
          let detail = `${res.status} ${res.statusText}`;
          try {
            const body = (await res.json()) as { detail?: string };
            if (typeof body?.detail === 'string') detail = body.detail;
          } catch {
            // non-JSON
          }
          throw new Error(detail);
        }
        return (await res.json()) as UniverseSnapshot;
      })
      .then((data) => setState({ status: 'ready', data, error: null }))
      .catch((err: unknown) => {
        if (controller.signal.aborted) return;
        setState({ status: 'error', data: null, error: err instanceof Error ? err.message : String(err) });
      });
    return () => controller.abort();
  }, []);

  return state;
}
